module.exports = __webpack_public_path__ + "static/media/woman_poster.b4f97644.jpg";